import { InjectionToken, Signal } from '@angular/core';
import { ProjectOpenMode } from '@infinitform/platform-core';

/** The fields needed to open a project in its editor. */
export interface OpenableProject {
  id: string;
  name: string;
  projectType?: string | null;
}

/** Projects opened inside the cloud cabinet. Provided only by the cloud cabinet app. */
export interface OpenProjectsApi {
  /** False when the editor address is not configured; projects then open in a new browser tab. */
  readonly available: boolean;
  readonly openMode: Signal<ProjectOpenMode>;
  /** True when the project is already open, or there is room for another one. */
  canOpenHere(projectId: string): boolean;
  open(project: OpenableProject): void;
  setOpenMode(mode: ProjectOpenMode, persist: boolean): void;
}

export const OPEN_PROJECTS = new InjectionToken<OpenProjectsApi>('OpenProjects');
